<template>
	<nav
		v-on-clickaway="hideMenu"
		class="navbar is-fixed-top is-black"
		role="navigation"
		aria-label="main navigation">
		<div class="navbar-brand">
			<dp-link route-name="character" class="navbar-item">
				<dp-svg class="icon is-medium has-color-light" svg="logo" />
			</dp-link>
			<div class="navbar-item">
				<div>
					<h1 class="title has-text-white-bis is-6">
						{{ $t('title.appMain') }}
					</h1>
					<h1 class="subtitle has-text-grey-lighter is-7">
						{{ $t('title.appSubtitle') }}
					</h1>
				</div>
			</div>
			<a
				:class="{ 'is-active': menuActive }"
				role="button"
				class="navbar-burger burger"
				aria-label="menu"
				aria-expanded="false"
				data-target="navbarBasicExample"
				@click="toggleMenu">
				<span aria-hidden="true" />
				<span aria-hidden="true" />
				<span aria-hidden="true" />
			</a>
		</div>

		<div id="navbarBasicExample" :class="{ 'is-active': menuActive }" class="navbar-menu has-background-black">
			<div class="navbar-start">
				<dp-link
					v-for="character in characters"
					:key="character.id"
					:params="{ id: character.id }"
					class="navbar-item is-tab">
					<a v-t="originResourceKeyOf(character)" />
				</dp-link>
				<div class="navbar-item">
					<div class="buttons">
						<button v-if="canAddCharacter" class="button is-primary" @click="addCharacter">
							<dp-svg svg="combatAbilityLeadership" class="icon" />
							<span v-t="'action.addCharacter'" />
						</button>
						<button v-if="canRemoveCharacter" class="button is-danger" @click="removeCharacter">
							<dp-svg svg="derivedStatCritMultiplier" class="icon" />
							<span v-t="'action.removeCharacter'" />
						</button>
					</div>
				</div>
				<div class="navbar-item">
					<the-import-export />
				</div>
			</div>

			<div class="navbar-end">
				<div class="navbar-item has-dropdown is-hoverable">
					<div class="navbar-link is-hidden-touch">
						<a v-t="'action.showMore'" />
					</div>
					<div class="navbar-dropdown has-background-black is-right">
						<div class="navbar-item">
							<a v-t="'workingOn.currently'" :href="$t('workingOn.link')" target="_blank" />
						</div>
						<div class="navbar-item">
							<a v-t="'action.giveFeedback'" href="https://www.reddit.com/r/DivinityOriginalSin/comments/9v33u4/divinity_2_planner/" target="_blank" />
						</div>
					</div>
				</div>
				<div class="navbar-item">
					<button
						v-t="'action.resetBuilds'"
						class="button is-danger"
						@click="resetBuilds" />
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { toOriginProp } from 'src/store';
import TheImportExport from './the-import-export';

export default {
	components: { TheImportExport },
	data: () => ({ menuActive: false }),
	computed: {
		...mapState(['selectedId']),
		...mapGetters(['characters', 'canAddCharacter', 'canRemoveCharacter', 'stateData']),
		homeRoute() {
			const { params, query } = this.$route;
			return { name: 'character', params, query };
		},
	},
	methods: {
		...mapActions(['selectId', 'addCharacter', 'removeCharacter', 'resetBuilds']),
		originResourceKeyOf({ origin }) {
			return toOriginProp('resourceKey', origin);
		},
		hideMenu() { this.menuActive = false; },
		toggleMenu() { this.menuActive = !this.menuActive; },
	},
};
</script>

<style scoped>
.has-margin-right {
	margin-right: 0.25rem;
}
</style>
